module.exports = __webpack_public_path__ + "static/media/shipBigPic.053961f5.jpeg";